export default class CartItem {
    constructor(item, license, price, type, discounted = false) {
        this.item = item;
        this.license = license;
        this.price = price;
        this.type = type;
        this.discounted = discounted;
    }

    get originalPrice() {
        switch (this.type) {
            case "beat":
                return +this.item.pricing[this.license.id].price;
            case "soundkit":
                return +this.license.price;
            default:
                return +this.item.price;
        }
    }

    get discountedAmount() {
        return this.originalPrice - this.price;
    }

    resetPrice() {
        this.price = this.originalPrice;
    }

    setPrice(price) {
        this.price = price;
    }

    licenseName() {
        return {
            'beat': this.license && this.license.name,
            'soundkit': this.license && this.license.pricingTemplateOption?.name
        }[this.type]
    }

    discountsMinQuantity() {
        return this.license.discounts[0].quantity
    }
}
